import React, {Component} from "react";
import {PAYLOAD} from "../payloads"

class Sender extends Component {
    state = {
        hours: null,
        minutes: null,
    };

    componentDidMount() {
        this.parseText(this.props.iterator);
        this.formatDate()
    }

    funcPars = (array, data, onMessage) => {
        return Array.prototype.forEach.call(array, (node) => {
            let pay = PAYLOAD(data, onMessage);

            if (pay && typeof pay === "string") {
                return node.innerHTML = pay ? pay : null
            } else if (pay && typeof pay === "object") {
                if (pay && pay.type === 'span') {
                    return node.innerHTML = pay ? pay.props.children : null
                } else if (pay && pay.type === 'a') {
                    // return node.innerHTML = pay ? pay.props.children : null
                }
            } else {
                return node.innerHTML = pay ? pay.props.children : null
            }
        });
    };

    parseText = (key) => {
        let tempArray = document.querySelectorAll(`[data-smile="sm-smile-${key}"]`);

        this.funcPars(tempArray, this.props.data, this.props.onMessage)
    };

    formatDate = () => {
        const date = new Date();
        let hours = date.getHours();
        if (hours < 10) hours = "0" + hours;
        let minutes = date.getMinutes();
        if (minutes < 10) minutes = "0" + minutes;

        this.setState({hours, minutes})
    };

    render() {
        let {
            onMessage,
            time,
            configIsShowingMessage,
            iterator
        } = this.props;

        const senderIcon = <svg xmlns="http://www.w3.org/2000/svg" width="17.338" height="10" viewBox="0 0 17.338 10">
            <path id="ic_done_all_24px"
                  d="M13.527,6.641,12.476,5.59,7.748,10.318,8.8,11.369ZM16.689,5.59,8.8,13.48,5.682,10.37,4.631,11.421,8.8,15.59l8.949-8.949ZM.41,11.421,4.579,15.59,5.63,14.539,1.469,10.37Z"
                  transform="translate(-0.41 -5.59)"
                  fill={`${window.STYLE_MESSAGE_ICON_DELIVERED_COLOR ? window.STYLE_MESSAGE_ICON_DELIVERED_COLOR : "#999"}`}/>
        </svg>;
        const senderIconDelivered = <svg xmlns="http://www.w3.org/2000/svg" width="17.338" height="10"
                                         viewBox="0 0 17.338 10">
            <path id="ic_done_all_24px"
                  d="M13.527,6.641,12.476,5.59,7.748,10.318,8.8,11.369ZM16.689,5.59,8.8,13.48,5.682,10.37,4.631,11.421,8.8,15.59l8.949-8.949ZM.41,11.421,4.579,15.59,5.63,14.539,1.469,10.37Z"
                  transform="translate(-0.41 -5.59)"
                  fill={`${window.STYLE_MESSAGE_ICON_DELIVERED_COLOR ? window.STYLE_MESSAGE_ICON_DELIVERED_COLOR : "#005ba8"}`}/>
        </svg>;

        return (<React.Fragment>
                {this.props.data && this.props.data.text &&
                <div className={`sender ${time ? 'withTime' : ''} ${configIsShowingMessage !== null ? 'viewed' : ''}`}>
                    <div className="sm-mes-content">
                        <div data-smile={`sm-smile-${iterator}`} className="w-sm-header">
                            {PAYLOAD(this.props.data, onMessage)}
                            {time ?
                                <span className="timer">{time} {senderIconDelivered}</span>
                                :
                                <span
                                    className="timer client-timer">
                                    {this.state.hours}:
                                    {this.state.minutes}{configIsShowingMessage !== null ? senderIconDelivered : senderIcon}
                                </span>
                            }
                        </div>
                    </div>
                </div>}
            </React.Fragment>
        )
    }
}

export default Sender


// WEBPACK FOOTER //
// ./src/components/Body/Sender/index.js